const dateOnlyConverter = (date) => {
    const dateArray = date.split('T');
    return dateArray[0] + ' 12:00:00';
}

export default dateOnlyConverter;